// Define custom validation functions globally
window.customValidations = {
    germanDate: value => /^\d{2}([.])\d{2}\1\d{4}$/.test(value),
    password2: value => /((?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[\W]).{8,20})/.test(value),
    street: value => /[a-zA-ZäöüßÄÖÜ \.]+ [0-9]+[a-zA-Z]?/.test(value),
    postcode: value => /^[0-9]{5}$/.test(value),
    city: value => /^[\D]+$/.test(value),
    phoneNumber: value => /^[0-9-()\\/+.\\s]*$/.test(value),
    orgNumber: value => /[0-9]{2}\/[0-9]{2}\/[0-9]{2}/.test(value),
    url: value => /((https|http):\/\/)((\w|-)+)(([.]|[/])((\w|-)+))+/.test(value),
    filePath: value => /\/[a-zA-Z/.]*/.test(value),
    IBAN: value => /^DE\d{20}$/.test(value.replace(/[ ]/g, "")) && isValidIBAN(value.replace(/[ ]/g, "")),
    BIC: value => /([a-zA-Z]{4}(de|DE)[a-zA-Z0-9]{2}([a-zA-Z0-9]{3})?)/.test(value.replace(/[ ]/g, "")),
    dbname: value => /^[\D]+$/.test(value),
    hostname: value => /[a-zA-Z][a-zA-Z0-9]*(-*[a-zA-Z0-9]+)/.test(value),
    notContainsSlashes: value => !value.includes("/")
};

// ✅ IBAN Validation Function
window.isValidIBAN = function (value) {
    // Move the first four characters to the end
    value = value.replace(/^(.{4})(.*)$/, "$2$1");

    // Convert letters to numbers
    value = value.replace(/[A-Z]/g, char => char.charCodeAt(0) - "A".charCodeAt(0) + 10);

    // Perform mod-97 validation
    let remainder = value;
    while (remainder.length > 2) {
        let chunk = remainder.slice(0, 9); // Take the first 9 digits
        remainder = (parseInt(chunk, 10) % 97) + remainder.slice(chunk.length); // Modulo 97
    }

    return parseInt(remainder, 10) % 97 === 1;
};